<template>
  <div class="spacer" />
</template>

<style scoped>
/* NOTE: cssクラス当てるだけなので、utlity.cssの方を使うようにする */
.spacer {
  flex: 1;
  flex-grow: 1;
}
</style>
